
    import { defineComponent, SetupContext, ref, PropType } from 'vue'
    import { searchMessageOnReply } from '@/store/reply'
    import useStore from '@/hooks/useStore'

    import Icon from '@/components/Icon/IndexIcon.vue'
    import MessageInteract from '@/components/Message/MessageInteract.vue'

    import { Message } from '@/types/message'
    import MessageHour from '@/components/Message/MessageHour.vue'
    import useMessage from '@/hooks/useMessage'

    export default defineComponent({
        emits: ['onClick'],

        components: {
            MessageHour,
            Icon,
            MessageInteract
        },

        props: {
            modelValue: {
                type: Object as PropType<Message>,
                default: () => ({})
            }
        },

        setup (props, { emit }: SetupContext) {
            const state = ref<Message>(props.modelValue)
            const store = useStore()
            const color = store.data.bgColor
            const onFocus = ref<boolean>(false)
            const msgPosition = state.value.position === 'sent' ? 'enviou' : 'recebeu'

            function handleFocus (): void {
                onFocus.value = !onFocus.value
            }

            function handleClickInteract (id: string): void {
                if (searchMessageOnReply(id)) {
                    onFocus.value = !onFocus.value
                }
            }

            const backgroundColor = useMessage().defineBackgroundColor(state.value.position)

            return {
                emit,
                onFocus,
                color,
                handleFocus,
                msgPosition,
                handleClickInteract,
                state,
                backgroundColor
            }
        }
    })
